import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material-ui icons
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import EmptyListIcon from 'assets/img/file.png';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import EditTable from 'components/Table/EditTable.js';
import Button from "components/CustomButtons/Button.js";

import styles from 'views/component/Styles.js';
import Confirm from 'views/component/Confirm.js';
import ImageUploader from 'views/component/ImageUploader.js';
import UploadConfirm from "views/component/SignUpConfirm.js";
import { infoColor } from "assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles(styles);

export default function ProjectList(props) {
    const { location } = props;
    const classes = useStyles();
    const history = useHistory();

    const [projectList, setProjectList] = useState([]);

    // default table data
    const [projectData, setProjectData] = useState({ scenarioList: [] });
    const [scenarioData, setScenarioData] = useState({ testcaseList: [] });

    // editable table data
    const [projectDataEdit, setProjectDataEdit] = useState({ scenarioList: [] });
    const [scenarioDataEdit, setScenarioDataEdit] = useState({ testcaseList: [] });

    // editable toggle
    const [editableScenarioList, setEditableScenarioList] = useState(false);
    const [editableTestcaseList, setEditableTestcaseList] = useState(false);

    // alert
    const [scenarioConfirmShow, showScenarioConfirm] = useState(false);
    const [testcaseConfirmShow, showTestcaseConfirm] = useState(false);
    const [uploadConfirmShow, showUploadConfirm] = useState(false);

    // selected
    const [projectSelected, setProjectSelected] = useState('');
    const [scenarioSelected, setScenarioSelected] = useState(-1);

    const [showScenarioCreateDiv, setScenarioShowCreateDiv] = useState(true);
    const [showTestcaseCreateDiv, setTestcaseShowCreateDiv] = useState(true);

    useEffect(() => {
        axios.get('data/project/list')
            .then(response => {
                let projectList = response.data;
                if (window.sessionStorage.getItem('isAdmin') === 'false'){
                    const auth = window.sessionStorage.getItem('projectList').split(',').map(item => parseInt(item));
                    projectList = projectList.filter(item => auth.includes(item.projectId));
                }
                setProjectList(projectList);
                if (location.state && location.state.projectId) {
                    setProjectSelected(location.state.projectId);
                }
            });
    }, [location]);

    useEffect(() => {
        if (projectSelected) {
            axios.get('data/project/view/' + projectSelected)
                .then(response => {
                    setProjectData(response.data);
                    setEditableScenarioList(false);
                    setScenarioData({ testcaseList: [] });
                    if (location.state && location.state.projectId && location.state.scenarioId) {
                        handleScenarioClick({ scenarioId: location.state.scenarioId });
                    }
                });
        }
    }, [projectSelected]);

    useEffect(() => {
        setScenarioSelected(projectData.scenarioList.findIndex((item) => { return item.scenarioId === scenarioData.scenarioId; }));
    }, [scenarioData, projectData]);

    const handleScenarioClick = function (data, e) {
        axios.get('data/scenario/view/' + data.scenarioId).then(response => {
            response.data.testcaseList.map(item => { item.simulateTime = item.simulateTime / 60; });
            setScenarioData(response.data);
            setEditableTestcaseList(false);
        });
    };
    const handleTestcaseClick = function (data, e) {
        history.push('testcase/info', {
            "projectId": projectData.projectId,
            "scenarioId": scenarioData.scenarioId,
            "testcaseId": data.testcaseId
        });
    }

    const clickScenarioAddButton = function () {
        let tempData = { ...projectDataEdit };
        tempData.scenarioList.push({ name: "", createDate: "" });
        setProjectDataEdit(tempData);
    };
    const clickScenarioEditButton = function () {
        setProjectDataEdit({ ...JSON.parse(JSON.stringify(projectData)), removedScenarioList: [] });
        setEditableScenarioList(true);
    };
    const handleScenarioChange = function (row, col, value) {
        let tempData = { ...projectDataEdit };
        tempData.scenarioList[row][col] = value;
        tempData.scenarioList[row].updated = true;
        setProjectDataEdit(tempData);
    };
    const handleScenarioRemove = function (row) {
        let tempData = { ...projectDataEdit };
        let removedScenario = tempData.scenarioList.splice(row, 1);
        tempData.removedScenarioList = [...tempData.removedScenarioList, removedScenario[0]];
        setProjectDataEdit(tempData);
    };
    const onScenarioConfirm = function (result) {
        if (result) {
            axios.post('data/scenario/listedit',
                { ...projectDataEdit, scenarioList: projectDataEdit.scenarioList.filter(scenario => scenario.updated) })
                .then(response => {
                    setProjectData(response.data);
                    setEditableScenarioList(false);
                });
        }
        showScenarioConfirm(false);
    };

    const clickTestcaseAddButton = function () {
        let tempData = { ...scenarioDataEdit };
        tempData.testcaseList.push({ name: "", createDate: "", simulateTime: "", logTerm: 10, unityTerm: 10 });
        setScenarioDataEdit(tempData);
    };
    const clickTestcaseEditButton = function () {
        setScenarioDataEdit({ ...JSON.parse(JSON.stringify(scenarioData)), removedTestcaseList: [] });
        setEditableTestcaseList(true);
    };
    const handleTestcaseChange = function (row, col, value) {
        let tempData = { ...scenarioDataEdit };
        tempData.testcaseList[row][col] = value;
        tempData.testcaseList[row].updated = true;
        setScenarioDataEdit(tempData);
    }
    const handleTestcaseRemove = function (row) {
        let tempData = { ...scenarioDataEdit };
        let removedTestcase = tempData.testcaseList.splice(row, 1);
        tempData.removedTestcaseList = [...tempData.removedTestcaseList, removedTestcase[0]];
        setScenarioDataEdit(tempData);
    };
    const onTestcaseConfirm = function (result) {
        if (result) {
            scenarioDataEdit.testcaseList.map(item => { item.simulateTime = item.simulateTime * 60 });
            axios.post('data/testcase/listedit',
                { ...scenarioDataEdit, testcaseList: scenarioDataEdit.testcaseList.filter(testcase => testcase.updated) })
                .then(response => {
                    response.data.testcaseList.map(item => { item.simulateTime = item.simulateTime / 60; });
                    setScenarioData(response.data);
                    setEditableTestcaseList(false);
                });
        }
        showTestcaseConfirm(false);
    };

    const onUploadSuccess = function () {
        showUploadConfirm(false);
    };

    const clickScenarioCreateButton = function () {
        setScenarioShowCreateDiv(false);
        clickScenarioEditButton();
    };
    const clickTestcaseCreateButton = function () {
        setTestcaseShowCreateDiv(false);
        clickTestcaseEditButton();
    };

    const clickScenarioCancelButton = function () {
        if (projectDataEdit.scenarioList.length === 0) {
            setTestcaseShowCreateDiv(true);
        }
        setEditableScenarioList(false);
    };
    const clickTestcaseCancelButton = function () {
        if (scenarioDataEdit.testcaseList.length === 0) {
            setTestcaseShowCreateDiv(true);
        }
        setEditableTestcaseList(false);
    };

    const onProjectChange = function (selectedProjectId) {
        setProjectSelected(selectedProjectId);
        history.push('/project/list', { "projectId": selectedProjectId });
    };

    return (
        <>
            <GridContainer>
                <GridItem xs={12} md={2}>
                    <FormControl fullWidth className={classes.selectFormControlInfo}>
                        <InputLabel htmlFor="projectSelect" className={classes.selectLabel}>
                            고객사
                        </InputLabel>
                        <Select MenuProps={{ className: classes.selectMenu }} classes={{ select: classes.select }}
                            value={projectSelected} onChange={e => { onProjectChange(e.target.value) }} inputProps={{ id: "projectSelect" }}>
                            {projectList.map((project) => {
                                return <MenuItem classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}
                                    value={project.projectId} key={project.projectId}>
                                    {project.name}
                                </MenuItem>;
                            })}
                        </Select>
                    </FormControl>
                </GridItem>
                <GridItem xs={12} md={10}>
                </GridItem>
                {projectData.name ? (
                    <GridItem xs={12} md={6} className={classes.collapsed}>
                        <div className={classes.cellContentProject} style={{ height: 'calc(100vh - 60px)' }}>
                            <h4><b>프로젝트 목록</b></h4>
                            {projectData.scenarioList.length === 0 && showScenarioCreateDiv ? <>
                                <div className={classes.createScenario}>
                                    <div className={classes.dropzoneText}>
                                        <div>프로젝트가 없습니다.<br />생성하기 버튼을 눌러 프로젝트를 생성해주세요.</div>
                                        <Button color="info" style={{ marginTop: 10 }} onClick={clickScenarioCreateButton}>생성하기</Button>
                                    </div>
                                </div>
                            </> : <>
                                    {editableScenarioList ?
                                        <>
                                            <Confirm show={scenarioConfirmShow} title="수정 사항 저장" text="수정된 프로젝트 목록을 저장합니다."
                                                onConfirm={onScenarioConfirm} confirmText="저장" type='info' />
                                            <EditTable
                                                tableHeaderColor="info"
                                                tableHead={['프로젝트 명', '생성일', '가로(m)', '세로(m)']}
                                                tableCols={['name', 'createDate', 'x', 'y']}
                                                tableData={projectDataEdit.scenarioList}
                                                underlineColor="info"
                                                onChange={handleScenarioChange}
                                                onRemove={handleScenarioRemove}
                                                fixed={['createDate']}
                                            />
                                            <Button color="info" className={classes.right} size="sm" onClick={clickScenarioAddButton}>추가</Button>
                                            <Button color="danger" className={classes.right} size="sm" onClick={clickScenarioCancelButton}>취소</Button>
                                            <Button color="success" className={classes.right} size="sm" onClick={e => { showScenarioConfirm(true); }}>저장</Button>
                                        </> :
                                        <>
                                            <Table striped hover select="info"
                                                selected={scenarioSelected}
                                                tableHeaderColor="info"
                                                tableHead={['프로젝트 명', '생성일', '가로(m)', '세로(m)']}
                                                tableCols={['name', 'createDate', 'x', 'y']}
                                                tableData={projectData.scenarioList}
                                                onRowClick={handleScenarioClick}
                                            />
                                            <Button color="infoOutline" className={classes.right} size="sm" onClick={clickScenarioEditButton}>수정</Button>
                                        </>
                                    }
                                </>}
                        </div>
                    </GridItem>
                ) : <GridItem xs={12} md={6} className={classes.collapsed}>
                        <div className={classes.cellContentProject} style={{ height: 'calc(100vh - 60px)' }}>
                            <h4><b>프로젝트 목록</b></h4>
                            <div className={classes.createScenario}>
                                <div className={classes.dropzoneText}>
                                    <img src={EmptyListIcon}
                                        width='70'
                                        height='70'
                                        style={{ margin: 10, marginBottom: 10 }} />
                                    <div>고객사를 선택해주세요.</div>
                                </div>
                            </div>
                        </div>
                    </GridItem>}
                {scenarioData.name ? (
                    <>
                        <GridItem xs={12} md={6} className={classes.collapsed}>
                            <div className={classes.cellContentProject}
                                style={{ height: '50%', maxHeight: 'calc(50vh - 30px)', borderBottom: '1px solid ' + infoColor[0] }}>
                                <h4><b>시나리오 목록</b></h4>
                                {scenarioData.testcaseList.length === 0 && showTestcaseCreateDiv ? <>
                                    <div className={classes.createScenario}>
                                        <div className={classes.dropzoneText}>
                                            <div>시나리오가 없습니다.<br />생성하기 버튼을 눌러 시나리오를 생성해주세요.</div>
                                            <Button color="info" style={{ marginTop: 10 }} onClick={clickTestcaseCreateButton}>생성하기</Button>
                                        </div>
                                    </div>
                                </> : <>
                                        {editableTestcaseList ? <>
                                            <Confirm show={testcaseConfirmShow} title="수정 사항 저장" text="수정된 시나리오 목록을 저장합니다."
                                                onConfirm={onTestcaseConfirm} confirmText="저장" type='info' />
                                            <EditTable
                                                tableHeaderColor="info"
                                                tableHead={["시나리오 명", "모의시간(분)", "생성일", '진행상태']}
                                                tableCols={["name", "simulateTime", "createDate", 'stateName']}
                                                tableData={scenarioDataEdit.testcaseList}
                                                underlineColor="info"
                                                onChange={handleTestcaseChange}
                                                onRemove={handleTestcaseRemove}
                                                fixed={['createDate', 'stateName']}
                                            />
                                            <Button color="info" className={classes.right} size="sm" onClick={clickTestcaseAddButton}>추가</Button>
                                            <Button color="danger" className={classes.right} size="sm" onClick={clickTestcaseCancelButton}>취소</Button>
                                            <Button color="success" className={classes.right} size="sm" onClick={e => { showTestcaseConfirm(true); }}>저장</Button>
                                        </>
                                            : <>
                                                <Table striped hover
                                                    tableHeaderColor="info"
                                                    tableHead={["시나리오 명", "모의시간(분)", "생성일", '진행상태']}
                                                    tableCols={["name", "simulateTime", "createDate", 'stateName']}
                                                    tableData={scenarioData.testcaseList}
                                                    onRowClick={handleTestcaseClick}
                                                />
                                                <Button color="infoOutline" className={classes.right} size="sm" onClick={clickTestcaseEditButton}>수정</Button>
                                            </>}
                                    </>}
                            </div>
                            <UploadConfirm show={uploadConfirmShow} title="업로드 되었습니다" onConfirm={onUploadSuccess}></UploadConfirm>
                            <div className={classes.cellContentProject} style={{ height: '50%' }}>
                                <h4><b>도면</b></h4>
                                <ImageUploader paramName="drawingFile" url={'data/upload/drawing/' + scenarioData.scenarioId}
                                    addButtonProps={{ color: "info" }} saveButtonProps={{ color: "success" }}
                                    changeButtonProps={{ color: "rose" }} removeButtonProps={{ color: "danger" }}
                                    cancelButtonProps={{ color: "warning" }}
                                    onFileUpload={e => { showUploadConfirm(true); }}
                                    prevUrl={scenarioData.drawing ? ((axios.defaults.baseURL ? axios.defaults.baseURL : process.env.PUBLIC_URL) + '/data/download/drawing/' + scenarioData.scenarioId) : undefined}
                                />
                            </div>
                        </GridItem>
                    </>) : <GridItem xs={12} md={6} className={classes.collapsed}>
                        <div className={classes.cellContentProject} style={{ height: '50%', borderBottom: '1px solid ' + infoColor[0] }}>
                            <h4><b>시나리오 목록</b></h4>
                            <div className={classes.createScenario}>
                                <div className={classes.dropzoneText}>
                                    <img src={EmptyListIcon}
                                        width='70'
                                        height='70'
                                        style={{ margin: 10, marginBottom: 10 }} />
                                    <div>프로젝트를 선택해주세요.</div>
                                </div>
                            </div>
                        </div>
                        <div className={classes.cellContentProject} style={{ height: '50%' }}>
                            <h4><b>도면</b></h4>
                            <div className={classes.createScenario}>
                                <div className={classes.dropzoneText}>
                                    <img src={EmptyListIcon}
                                        width='70'
                                        height='70'
                                        style={{ margin: 10, marginBottom: 10 }} />
                                    <div>프로젝트를 선택해주세요.</div>
                                </div>
                            </div>
                        </div>
                    </GridItem>}
            </GridContainer>
        </>
    );
}